<template>
  <v-card max-width="768" tile>
    <v-card-title class="justify-end px-3 py-2">
      <a @click="closeDialog()" id="btn__6A6Ir554xk6ERTUG5VrKOA==">
        <v-icon large> mdi-close </v-icon>
      </a>
    </v-card-title>
    <v-card-text class="text-center px-4">
      <v-row cols="12" class="mt-2" no-gutters>
        <v-col cols="12">
          <p class="mb-5 font--m-3">업로드 이용 전 꼭 확인해주세요.</p>
        </v-col>
      </v-row>

      <v-row class="mt-10" no-gutters>
        <v-col cols="12">
          <div class="d-flex align-center justify-center">
            <p class="step-circle font--m-4 mr-2">1</p>
            <p class="mb-0" style="line-height: 1.5">
              업로드된 주문 목록을 기반으로<br />
              사입시 신청이 접수됩니다.
            </p>
          </div>
        </v-col>

        <v-col cols="12" class="mt-5">
          <div class="d-flex align-center justify-center">
            <p class="step-circle font--m-4 mr-2">2</p>
            <p class="mb-0" style="line-height: 1.5">
              접수 후 결과는 담당자를 통하여<br />
              유선으로 안내될 예정입니다.
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-10">
        <v-col cols="12">
          <BasicButton
            height="62px"
            color="pink"
            @click="chooseFiles('imageUpload')"
            :disabled="uploadLoading"
            :loading="uploadLoading"
          >
            사진으로 업로드하기
          </BasicButton>
          <v-file-input
            v-model="imageFile.file"
            id="imageUpload"
            :accept="accept.image"
            label=""
            prepend-icon
            append-icon="mdi-cloud-upload"
            outlined
            hide-input
            @change="upload({ type: 'image', file: imageFile })"
          >
          </v-file-input>
        </v-col>

        <v-col cols="12" class="mt-3">
          <BasicButton
            height="62px"
            color="pink"
            @click="chooseFiles('excelUpload')"
            :disabled="uploadLoading"
            :loading="uploadLoading"
          >
            엑셀로 업로드하기
          </BasicButton>
          <v-file-input
            v-model="excelFile.file"
            :accept="accept.excel"
            id="excelUpload"
            label=""
            prepend-icon
            append-icon="mdi-cloud-upload"
            outlined
            hide-input
            @change="upload({ type: 'excel', file: excelFile })"
          >
          </v-file-input>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-10">
        <v-col cols="2"></v-col>
        <v-col cols="8">
          <p class="color--pinkred-110 mb-0">
            * 주문 목록을 사진 또는 엑셀로 업로드 하실 경우 쇼핑몰에서 불러온 주문 목록은 사용이
            불가능합니다.
          </p>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      accept: {
        excel: '.xlsx,.xls,.csv,.pdf',
        image: 'image/*',
      },
      imageFile: {
        date: null,
        file: null,
      },
      excelFile: {
        date: null,
        file: null,
      },
      uploadLoading: false,
      files: [],
      imageFiles: [],
      excelFiles: [],
    }
  },
  watch: {
    async files(v) {
      const excelExp = this.accept.excel.split(',')
      this.imageFiles = []
      this.excelFiles = []

      v.forEach((f) => {
        const fileName = f.filename
        const i = fileName.lastIndexOf('.')
        if (excelExp.includes(fileName.substring(i))) {
          this.excelFiles.push(f)
        } else {
          this.imageFiles.push(f)
        }
      })

      if (this.imageFiles.length > 0 || this.excelFiles.length > 0) {
        await this.$swal.basic.success({
          html: `파일이 업로드 되었습니다.`,
        })

        this.$router.push({ name: 'main' })
      }
    },
  },
  async created() {
    this.imageFile = await this.initFile()
    this.excelFile = await this.initFile()
    this.getFiles(this.imageFile.date)
  },
  methods: {
    ...mapActions('overlay', {
      closeDialog: 'closeOverlay',
    }),
    ...mapActions('product', [
      'addProductFile',
      'getNowProductDate',
      'getProductFiles',
      'deleteProductFile',
    ]),
    async initFile() {
      const date = await this.getNowProductDate()
      return {
        date,
        file: null,
      }
    },
    async upload({ type, file }) {
      if (!file.file) {
        return
      }

      this[`${type}Files`].forEach(async (file) => {
        await this.deleteProductFile(file)
      })

      try {
        this.uploadLoading = true
        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `
          해당 파일을 업로드 하시겠습니까? <br />
          파일을 기준으로 사입비가 신청됩니다.
          <br /><br />
          <span class="color--green">
          ${file.file.name}
          </span>
        `,
          confirmButtonText: '업로드하기',
        })
        if (isConfirmed === true) {
          await this.addProductFile(file)
          await this.initFile()
          await this.getFiles(file.date)
        }
      } finally {
        this.uploadLoading = false
      }
    },
    async getFiles(date) {
      this.files = await this.getProductFiles({ date })
    },
    chooseFiles(type) {
      document.getElementById(type).click()
    },
  },
}
</script>

<style lang="scss" scoped>
.step-circle {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;
  background-color: $pinkred-110;
  border-radius: 100%;
  color: white;

  margin-bottom: 0;
}
</style>
